// Globals
import React from 'react';

// UI
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

// Locals
import styles from './Components.module.css';

// Types

const loadingIcon = <LoadingOutlined className="giideLoadingIcon" spin />;

const LoadingIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <Spin
      indicator={loadingIcon}
      className={`${className ?? styles.previewLoaderIcon}`}
    />
  );
};

export default LoadingIcon;
